<script>
import BaseFilter from "./BaseFilter";
import { mapGetters } from "vuex";

export default {
  name: "ProvinceSearch",
  extends: BaseFilter,
  computed: {
    ...mapGetters({
      options: "provinces",
    }),
  },
  data() {
    return {
      placeholder: "Alle provincies",
      filtername: "provincies",
      type: "provincies",
    };
  },
};
</script>
